import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import { getExcludedAllergens } from '../../const/AllergenHelper'
import type { ItemSubCategoryResult } from '../../data/ItemSubCategoryFragment'
import type { ProductBannerResult } from '../../data/ProductFragment'
import { ProductBanner } from '../product/ProductBanner'
import { ProductBannerLocked } from '../product/ProductBannerLocked'
import { RegisterBanner } from '../static/RegisterBanner'
import { Ellipsis } from './Ellipsis'
import style from './Listing.module.sass'

export type ListingProductsLockedProps = {
	product: ProductBannerResult | undefined
	bestProduct: ProductBannerResult | undefined | null
	allAllergens: ItemSubCategoryResult[]
	hasGreenTag?: boolean
	totalCount: number
	tag?: 'green' | 'red' | undefined
	dogDailyEnergyRequirement: number
	productIndex: number | null | undefined
	openModal: () => void
}

export const ListingProductsLocked: FunctionComponent<ListingProductsLockedProps> = ({
	product,
	allAllergens,
	tag,
	bestProduct,
	totalCount,
	productIndex /* from 1 */,
	dogDailyEnergyRequirement,
	openModal,
}) => {
	return (
		<>
			<div className={clsx(style.bannerGroup, style.bannerGroupLocked)}>
				{bestProduct && bestProduct.id !== product?.id && (
					<div className={style.cardWrapper}>
						<ProductBanner
							dogDailyEnergyRequirement={dogDailyEnergyRequirement}
							product={bestProduct}
							position={0}
							isHighlighted={productIndex === 1 ? 'green' : undefined}
							isTopProduct
							openModal={openModal}
							excludedAllergens={getExcludedAllergens(allAllergens, bestProduct)}
						/>
					</div>
				)}
				{productIndex && productIndex > 1
					? [...Array(Number(productIndex) <= 3 ? Number(productIndex) - 2 : 2)].map((_elem, index) => (
							<div key={index} className={clsx(style.cardWrapper, style.cardWrapperLoading)}>
								<ProductBannerLocked orderIndex={index + 2} />
							</div>
						))
					: undefined}

				{productIndex && productIndex > 4 ? <Ellipsis /> : undefined}
				{product && productIndex ? (
					<div className={clsx(style.cardWrapper, tag && style.cardWrapperNoAfter)}>
						<ProductBanner
							dogDailyEnergyRequirement={dogDailyEnergyRequirement}
							product={product}
							isHighlighted={tag}
							openModal={openModal}
							position={productIndex - 1}
							isTop={typeof productIndex === 'number' && productIndex <= 3}
							excludedAllergens={getExcludedAllergens(allAllergens, product)}
						/>
					</div>
				) : undefined}
				{[...Array(totalCount > 3 ? 2 : productIndex && productIndex > 4 ? totalCount - 1 : totalCount - 2)].map(
					(_elem, index) => (
						<div className={style.cardWrapper} key={index}>
							<div className={clsx(style.cardWrapper, style.cardWrapperLoading)}>
								<ProductBannerLocked
									orderIndex={productIndex ? (productIndex >= 3 ? index + 5 : index + productIndex + 1) : index + 2}
								/>
							</div>
						</div>
					),
				)}
				{totalCount > 3 && <Ellipsis />}
				<RegisterBanner />
			</div>
		</>
	)
}
